// Renders the lightweight blog body format:
//  - lines starting with "## " => subheading
//  - lines starting with "> "  => blockquote
//  - blank-line separated blocks => paragraphs
//  - inside every block: *italic*, **bold**, _italic_ are supported
import { renderInline } from "./inlineFormat";

export default function PostBody({ body }) {
  const blocks = body.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className="space-y-5">
      {blocks.map((block, i) => {
        if (block.startsWith("## ")) {
          return (
            <h2 key={i} className="pt-4 font-display text-2xl font-semibold text-cream md:text-3xl">
              {renderInline(block.slice(3))}
            </h2>
          );
        }
        if (block.startsWith("> ")) {
          return (
            <blockquote
              key={i}
              className="border-l-2 border-gold pl-5 font-display text-lg italic leading-relaxed text-gold-soft"
            >
              {renderInline(block.slice(2))}
            </blockquote>
          );
        }
        return (
          <p key={i} className="font-body text-lg leading-relaxed text-slate-300">
            {block.split("\n").map((line, j) => (
              <span key={j}>
                {renderInline(line)}
                {j < block.split("\n").length - 1 && <br />}
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
}
